<template>
  <div class="card-plans-base">
    <section class="card-plans-base-section">
      <div class="card-plans-base-text">

        <span class="card-plans-base-title">
          <img src="../assets/images/SVG/plan_lite_logo_SVG.svg" alt/>
          <h1>{{ planName }}</h1>
        </span>

        <hr>

        <span>${{ price }}</span>
        <u>95</u>
        <h2>{{ $t('plans.monthly-title') }}</h2>
      </div>

      <div class="card-plans-base-cta">
        <s-button :class="btn" :btn-link="btnLink">{{msg}}</s-button>
      </div>
    </section>
  </div>
</template>

<script>

import SButton from "@/components/SButton.vue";

export default {
  name: 'CardPlanBase',
  components: {
    SButton,
  },
  props: {
    planName: String,
    price: String,
    btn: String,
    btnLink: String,
    msg: String
  }
}
</script>

